module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "delete-count-down"
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.$t("countdown.confirmdelete")) + " "), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\"" + _vm._s(_vm.action.data.name) + "\"")])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("countdown.btncancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteThisCountDown(_vm.action);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("countdown.btndelete")))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe457d48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/countdown/actions/DeleteCountDown.vue
// module id = 3409
// module chunks = 0